// extracted by mini-css-extract-plugin
export default {"button":"ek-z","reviewSort":"fk-z"};